import { PropsWithChildren } from 'react';

import { AccountModel } from '@portal-clients/account';

import {
  usePrefetchAllAccountTransactions,
  usePrefetchNewsQuery,
  usePrefetchSiteUnits,
} from '../data';

export interface PrefetchProps {
  accounts?: AccountModel[];
}

export const Prefetch = (props: PropsWithChildren<PrefetchProps>) => {
  usePrefetchSiteUnits();
  usePrefetchAllAccountTransactions(
    (props?.accounts ?? []).map((account) => account.id),
  );
  usePrefetchNewsQuery();

  return <>{props.children}</>;
};
